const {
  getOffsetTop,
  getOffsetLeft,
  viewportSize,
  prefersReducedMotion,
  isTouchDevice,
} = window.BAO.Utils

class FloatingPlayButton extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.translateX = 0
    this.translateY = 0

    this.setupListeners()
  }

  setupListeners () {
    if (!this.containerEl || !this.cursorEnabled) return

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)

    this.listeners.add(this.containerEl, 'mouseleave', this.handleMouseLeave)
    this.listeners.add(this.containerEl, 'mousemove', this.handleMouseMove)
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.style.transform = `translate3d(${this.translateX}px, ${this.translateY}px, 0px)`
  }

  handleMouseMove (event) {
    if (!this.interacting) {
      /* Delay setting this to true as we want a slower transition */
      this.interactionTimeout = setTimeout(() => {
        this.setAttribute('data-interacting', 'true')
      }, 500)
    }

    const rect = event.target.getBoundingClientRect()

    const yOffset = getOffsetTop(this, this.containerEl) + this.offsetHeight / 2
    const xOffset = getOffsetLeft(this, this.containerEl) + this.offsetWidth / 2

    const topOffset = event.clientY - rect.top
    const leftOffset = event.clientX - rect.left

    this.translateX = 0 - xOffset + leftOffset
    this.translateY = 0 - yOffset + topOffset

    this.requestTick()
  }

  handleMouseLeave () {
    if (this.interacting) {
      this.setAttribute('data-interacting', 'false')
      this.translateX = 0
      this.translateY = 0

      this.style.transform = `translate3d(0px, 0px, 0px)`
      if (this.interactionTimeout) {
        clearTimeout(this.interactionTimeout)
      }
    }
  }

  get containerEl () {
    if (!this.externalEls.container.exists) return
    return this.closest(this.externalEls.container.selector)
  }

  /* Custom cursor disabled on touch devices, mobile and for users who prefer reduced motion */
  get cursorEnabled () {
    return (
      !isTouchDevice() && !prefersReducedMotion() && viewportSize() !== 'xs'
    )
  }

  get interacting () {
    return this.dataset?.interacting === 'true'
  }
}

if (!customElements.get('floating-play-button')) {
  customElements.define('floating-play-button', FloatingPlayButton)
}
